import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Button, Card, Grid, Typography } from '@upperhand/playmaker';
import AvatarWithTextContainer from 'components/AvatarWithTextContainer';

import 'containers/AttendanceList/components/Attendee.css';

const Attendee = ({ bookedClientIds, clientId, clients, onCheckInClicked }) => {
  const client = clients[clientId];

  const { avatarName, src, primaryText } = client.avatarData;
  const isCheckedIn = !bookedClientIds.includes(clientId);

  return (
    <Grid item xs={12} key={clientId}>
      <Card
        classes={{
          root: isCheckedIn ? 'card__checkedIn card-content' : 'card-content',
        }}
      >
        <Grid
          alignItems="center"
          container
          justify="space-between"
          wrap="nowrap"
        >
          <AvatarWithTextContainer
            avatarName={avatarName}
            src={src}
            primaryText={primaryText}
          />
          <Grid item>
            {isCheckedIn ? (
              <Typography variant="h3">Checked in</Typography>
            ) : (
              <Button size="4x" onClick={() => onCheckInClicked(clientId)}>
                <Typography variant="h3">Check in</Typography>
              </Button>
            )}
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
};

Attendee.propTypes = {
  bookedClientIds: PropTypes.array.isRequired,
  clientId: PropTypes.number.isRequired,
  clients: PropTypes.object.isRequired,
  onCheckInClicked: PropTypes.func.isRequired,
};

const mapStateToProps = ({ entities: { clients } }) => ({
  clients: clients.data,
});

export default connect(mapStateToProps)(Attendee);
